import IconSpotify from "./icon-spotify";

export default IconSpotify;